export class CommunitySoaRequestRawDto {
    communityId: number;
    soaRequestId: number;
    soaFulfillmentId: number;
}
